'use client';

import Typography from '@ui/Typography';
import { hashtagsToDisplay } from '@utils/hashtagParser';
import { cx } from 'cva';
import linkifyHtml from 'linkify-html';
import { trim } from 'lodash-es';
import React, { useEffect, useRef, useState } from 'react';

const MAX_LINES_INIT = 3;
const LINE_HEIGHT = 24;
const linkifyOptions = {
  defaultProtocol: 'https',
  target: '_blank',
  className: 'hover:text-text-hyperlink',
};

function PostMessage(props) {
  const {
    message,
    featured = false,
    detailedPost = false,
    lineClamp = MAX_LINES_INIT,
    lineHeight = LINE_HEIGHT,
    className,
  } = props;
  const [paragraphs, setParagraphs] = useState(
    trim(message)
      .split('\n')
      .filter((item) => item.trim().length > 0),
  );

  const paragraphRef = useRef(null);
  const [processedMessage, setProcessedMessage] = useState([]);
  const [showFullText, setShowFullText] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);

  useEffect(() => {
    const paragraphElement = paragraphRef.current;
    if (paragraphElement) {
      const maxHeight = Math.ceil(lineClamp * lineHeight);
      if (paragraphElement.scrollHeight > maxHeight) {
        setShowReadMore(true);
        setShowFullText(false);
      }
    }

    if (detailedPost) {
      setTimeout(() => {
        handleSeeMoreClick();
      }, 500);
    }
  }, []);

  useEffect(() => {
    if (message) {
      const paras = message
        .trim()
        .split('\n')
        .filter((item) => item.trim().length > 0)
        .map((item) => {
          const processed = hashtagsToDisplay(item);
          return processed.map((p) => p.displayText).join('');
        });
      setParagraphs(paras);
    } else {
      setParagraphs([]);
    }

    // const processMessage = async () => {
    //   const processed = hashtagsToDisplay(message);
    //   const mentionedUserIds = processed
    //     .filter((item) => item.type === 'user' && item.id)
    //     .map((item) => item.id);
    //   if (mentionedUserIds.length > 0) {
    //     const mentionedUsers = await fetchMentionedUsers(mentionedUserIds);
    //     setProcessedMessage(
    //       processed.map((item) => {
    //         if (item.type === 'user' && item.id) {
    //           const user = mentionedUsers.find((u) => u.id === item.id);
    //           if (user) {
    //             return {
    //               ...item,
    //               displayText: `${user.first_name} ${user.last_name}`,
    //               access: true,
    //             };
    //           }
    //           return {
    //             ...item,
    //             access: false,
    //           };
    //         }
    //         return item;
    //       })
    //     );
    //   } else {
    //     setProcessedMessage(processed);
    //   }
    // };
    // processMessage();
  }, [message]);

  const handleSeeMoreClick = () => {
    setShowFullText(!showFullText);
  };

  const shouldShowSeeMore =
    paragraphs.length > 0 &&
    paragraphRef.current?.scrollHeight > lineClamp * lineHeight;

  return (
    <div className="w-full">
      <article
        className="prose max-w-none overflow-hidden [&_p]:mb-0"
        ref={paragraphRef}
        style={{
          maxHeight: showFullText ? 'none' : `${lineClamp * lineHeight}px`,
        }}>
        {featured
          ? paragraphs.slice(0, 1).map((paragraph, index) => (
              <Typography
                variant="body2"
                className="w-full truncate leading-[24px] group-hover:text-text-hyperlink"
                component="p"
                key={index}
                dangerouslySetInnerHTML={{
                  __html: linkifyHtml(
                    paragraph.length > 15
                      ? `${paragraph.substring(0, 35)}...`
                      : paragraph,
                    linkifyOptions,
                  ),
                }}
              />
            ))
          : paragraphs.map((paragraph, index) => (
              <Typography
                variant="body2"
                component="p"
                key={index}
                className="leading-[24px]"
                dangerouslySetInnerHTML={{
                  __html: linkifyHtml(paragraph, linkifyOptions),
                }}
              />
            ))}
      </article>

      {shouldShowSeeMore && (
        <div
          className={cx(
            'flex w-full justify-end',
            // !showFullText && `-translate-y-[21px]`,
            !showReadMore && 'hidden',
          )}>
          <button onClick={handleSeeMoreClick}>
            <Typography
              variant="body2"
              color="textSecondary"
              className={cx('ml-2 bg-white hover:text-primary', className)}>
              {showFullText ? 'see less' : '...see more'}
            </Typography>
          </button>
        </div>
      )}
    </div>
  );

  // return (
  //   <Typography variant="body2">
  //     {processedMessage.map((item) => {
  //       switch (item.type) {
  //         case 'hashtag': {
  //           return (
  //             <Link key={item.key} href={`/hashtags/${item.id}`}>
  //               {item.displayText}
  //             </Link>
  //           );
  //         }
  //         case 'user': {
  //           if (!item.access) {
  //             return (
  //               <Typography key={item.key} variant="body2" component="span">
  //                 {item.displayText}
  //               </Typography>
  //             );
  //           }
  //           return (
  //             <Link key={item.key} href={`/profile/${item.id}`}>
  //               {item.displayText}
  //             </Link>
  //           );
  //         }
  //         default: {
  //           return (
  //             <Typography key={item.key} variant="body2" component="span">
  //               {item.displayText}
  //             </Typography>
  //           );
  //         }
  //       }
  //     })}
  //   </Typography>
  // );
}

export default PostMessage;
